import { Component, inject, input } from '@angular/core';
import {
  JssModule,
  LinkField,
  TextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { CrntIcon } from '@essent/current-web-angular';
import { GenericLinkDirective } from '@core/jss-utils';
import { JssPlatformService } from '@core/jss-platform';

export interface ListLink {
  id: string;
  value: LinkField;
}

@Component({
  selector: 'wl-link-list',
  standalone: true,
  templateUrl: './link-list.component.html',
  styleUrls: [
    './link-list.component.ed.scss',
    './link-list.component.essent.scss',
  ],
  imports: [GenericLinkDirective, JssModule, CrntIcon],
})
export class LinkListComponent {
  readonly #jssPlatformService = inject(JssPlatformService);

  readonly title = input.required<TextField>();
  readonly linkList = input.required<ListLink[]>();
  readonly id = input.required<string>();

  readonly isContentEditorActive = this.#jssPlatformService.isEditorActive();

  showLink(link: LinkField) {
    return this.isContentEditorActive || Boolean(link.value?.href);
  }
}
